/**
 * @file patient-utils.js
 * @description Funciones utilitarias para datos de cobertura médica del paciente.
 * Soporta tres fuentes en orden de prioridad:
 * 1. patient.member (afiliado vinculado — obra social)
 * 2. patient.patient.medicalInsuranceObj (nueva estructura)
 * 3. patient.patient.medicalInsurance (estructura antigua)
 */

/**
 * @description Obtiene el número de afiliado del paciente
 * @param {Object} patient - Objeto paciente
 * @returns {string}
 */
export function getMedicalInsuranceNumber(patient) {
  // Desde member vinculado
  if (patient?.member?.memberNumber) {
    return patient.member.memberNumber;
  }
  if (!patient?.patient) return "N/A";
  // Nueva estructura
  if (patient.patient.medicalInsuranceObj?.number) {
    return patient.patient.medicalInsuranceObj.number;
  }
  // Fallback estructura antigua
  return patient.patient.medicalInsuranceNumber || "N/A";
}

/**
 * @description Obtiene el plan de cobertura del paciente
 * @param {Object} patient - Objeto paciente
 * @returns {string}
 */
export function getMedicalInsurancePlan(patient) {
  if (patient?.member?.plan) {
    const plan = patient.member.plan;
    // Si está populado como objeto, leer el name
    if (typeof plan === "object") return plan.name || "N/A";
    // Si es string ObjectId sin popular
    if (/^[0-9a-f]{24}$/.test(String(plan))) return "N/A";
    return plan;
  }
  if (!patient?.patient) return "N/A";
  if (patient.patient.medicalInsuranceObj?.plan) {
    return patient.patient.medicalInsuranceObj.plan;
  }
  return patient.patient.medicalInsurancePlan || "N/A";
}

/**
 * @description Obtiene el nombre del financiador del paciente
 * @param {Object} patient - Objeto paciente
 * @returns {string}
 */
export function getMedicalInsuranceName(patient) {
  // Desde member — plan populado con healthInsuranceName
  if (patient?.member?.plan?.healthInsuranceName) {
    return patient.member.plan.healthInsuranceName;
  }
  // Fallback a organization.name
  if (patient?.member?.organization?.name) {
    return patient.member.organization.name;
  }
  if (!patient?.patient) return "N/A";
  if (patient?.patient?.medicalInsuranceObj?.publicInsurance?.name) {
    return patient.patient.medicalInsuranceObj.publicInsurance.name;
  }
  if (patient?.patient?.medicalInsurance?.name) {
    return patient.patient.medicalInsurance.name;
  }
  return "N/A";
}
